<template>
    <div class="layout__width-90 layout__padding-clear">
        <div class="text__align-center text__colour-white layout__margin__bottom-25px">
            <div class="layout__padding-clear layout__width-80 layout__padding-40px-0">
                <div class="text__colour-teal text__size-50 text__style-bold-700">Merchandise</div>

                <p class="text__size-16 text__colour-grey layout__padding-20px">Your brand is unique, it’s a reflection
                    of who you are, which is why it needs to be consistently and professionally represented. We
                    understand the importance of being ahead of the competition and have a wide selection of merchandise
                    to make you stand out from the crowd.</p>
                <p class="text__size-16 text__colour-grey">For a bespoke quote, contact us today
                    on:</p>

                <div class="layout__padding-20px">
                    <a href="mailto:customer.services@ravensworth.co.uk" class="link__colour-teal text__style-bold-900"
                       target="_top"><p class="text__size-20 text__colour-red layout__padding__bottom-20">client.support@ravensworth.co.uk</p></a>

                    <p class="text__size-20 text__colour-red">0191 917 9331</p>
                </div>
              <router-link to="/contact">
                <el-button class="layout__width-200px button-red">Contact us</el-button>
              </router-link>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-cotton-bags.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Cotton Bags</div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £3.03</div>
                <div class="text__size-16">Product code: MO9283</div>
                <div class="text__size-16 layout__padding-5-0">Screenprint – 1 colour/1 side</div>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-pen-1.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Ball pens type 1
                </div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £1.35</div>
                <div class="text__size-16">Product code: KC6982</div>
                <div class="text__size-16 layout__padding-5-0">Padprint – 1 colour to the barrel</div>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-pen-2.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Ball pens type 2
                </div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £0.36</div>
                <div class="text__size-16">Product code: KC3315</div>
                <div class="text__size-16 layout__padding-5-0">Padprint – 1 colour to the barrel</div>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-trolley-keyrings.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Trolley keyrings
                </div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £1.85</div>
                <div class="text__size-16">Product code: MO9289</div>
                <div class="text__size-16 layout__padding-5-0">Padprint – 1 colour to 1 side</div>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-keyrings.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Keyrings</div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £1.16</div>
                <div class="text__size-16">Product code: KC6589</div>
                <div class="text__size-16 layout__padding-5-0">Padprint – 1 colour to 1 side</div>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-mug.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Mugs</div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £3.81</div>
                <div class="text__size-16">Product code: MO8040</div>
                <div class="text__size-16 layout__padding-5-0">Sublimation wrap print</div>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-umb.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Umbrellas</div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £9.16</div>
                <div class="text__size-16">Product code: MO8780</div>
                <div class="text__size-16 layout__padding-5-0">Screenprint – 1 colour/2 panels</div>
                <div class="text__size-16 layout__padding-5-0">Screenprint – 1 colour/4 panels (Every other panel)</div>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-water-bottles.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Water bottles
                </div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £3.44</div>
                <div class="text__size-16">Product code: MO9224</div>
                <div class="text__size-16 layout__padding-5-0">Screenprint – 1 colour wrap print</div>
            </div>
        </div>

        <div class="component__product-3">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-usb.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">USB sticks 4GB
                </div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £3.89</div>
                <div class="text__size-16">Product code: MO1001</div>
                <div class="text__size-16 layout__padding-5-0">Padprint – 1 colour to 1 side</div>
            </div>
        </div>

        <div class="component__product-3 layout__padding-clear">
            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/merch/Merch-coffee.jpg" class="layout__width-100">
            <div class="text__align-center layout__padding-20-0">
                <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Coffee cups</div>
                <div class="text__size-16 layout__padding-5-0 text__colour-red text__style-bold-700">From £2.78</div>
                <div class="text__size-16">Product code: UNI-TUM</div>
                <div class="text__size-16 layout__padding-5-0">Padprint – 1 colour to 1 side</div>
            </div>
        </div>


    </div>

</template>

<script>

    export default {
        name: "Merchandise",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    };
</script>